import AdsenseComponent from './AdsenseComponent.vue'

const Adsense = {
  install: Vue => {
    Vue.component('Adsense', AdsenseComponent)
  }
}

export default Adsense
